module.exports = __webpack_public_path__ + "static/assets/7f61489966d3271b66f7048f7472bb38.png";